<template>
  <div class="tariffs-info">
    <div class="public-container public-container-mobile flex flex-space-between flex-align-items-center">
      <NuxtImg src="/images/pages/tariffs/calculation.png" alt="" format="webp" loading="lazy" />
      <div class="tariffs-info-wrapper">
        <h2 id="order">{{ title }}</h2>
        <div class="color-primary text-h1 mt-20">
          {{ content.blocks?.order.countries }}
        </div>
        <div class="mt-30">
          {{ content.blocks?.order.listTitle }}
        </div>
        <div class="public-list-numeric mt-30">
          <div v-for="(item, index) in items" :key="index" class="public-list-numeric-item">
            <span>{{ index + 1 }}</span>
            <div>
              <b>{{ item.title }}</b>
              <div>{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useCityStore } from '~/stores/city'
import {getPageContent, replaceContentText} from '~/api/content';

const { currentCity } = storeToRefs(useCityStore())

const content = await getPageContent('/tariffs')

const items = computed(() => {
  const data = content.blocks?.order
  return [
    {
      title: data?.listItemTitle_0,
      text: data?.listItem_0
    },
    {
      title: data?.listItemTitle_1,
      text: data?.listItem_1
    },
    {
      title: data?.listItemTitle_2,
      text: data?.listItem_2
    },
  ]
})

const title = computed(() => {
  return replaceContentText(content.blocks?.order.title, { city: currentCity.value })
})
</script>
